import { User, UserRole } from '../types/user'

/**
 * Check if the current user has a given role on a specific entity (by entity_id or entity_code).
 * Admin (users.is_admin) does NOT bypass entity roles: admin is for user management,
 * not business actions. Pure SoD.
 */
export function hasRoleOnEntity(
  user: Pick<User, 'roles'> | undefined | null,
  role: UserRole,
  entityIdOrCode: string
): boolean {
  if (!user?.roles) return false
  return user.roles.some(
    (r) => r.role === role && (r.entity_id === entityIdOrCode || r.entity_code === entityIdOrCode)
  )
}

/**
 * Check if the user has a given role on at least one entity in the tenant.
 */
export function hasAnyEntityRole(
  user: Pick<User, 'roles'> | undefined | null,
  role: UserRole
): boolean {
  return user?.roles?.some((r) => r.role === role) ?? false
}

/**
 * List entity_ids where the user has a given role.
 * Used to filter dropdowns (e.g., new mandate entity picker).
 */
export function entityIdsWithRole(
  user: Pick<User, 'roles'> | undefined | null,
  role: UserRole
): Set<string> {
  if (!user?.roles) return new Set()
  return new Set(user.roles.filter((r) => r.role === role).map((r) => r.entity_id))
}

/**
 * List entity_codes where the user has a given role.
 */
export function entityCodesWithRole(
  user: Pick<User, 'roles'> | undefined | null,
  role: UserRole
): Set<string> {
  if (!user?.roles) return new Set()
  return new Set(user.roles.filter((r) => r.role === role).map((r) => r.entity_code))
}
